import Colors from '../../styles/colors';

const styles = (theme) => ({
    pageWrapper: {
        paddingTop: 100,
        backgroundColor: Colors.red,
        [theme.breakpoints.down('sm')]: {
            paddingTop: 60,
        },
    },
    topWrapper: {
        paddingTop: 60,
        backgroundColor: Colors.red,
        paddingBottom: 80,
        [theme.breakpoints.down('sm')]: {
            minHeight: 80,
            paddingBottom: 0,
        },
    },
    contentBuffer: {
        paddingTop: 50,
        backgroundColor: Colors.red,
    },
    contentWrapper: {
        paddingTop: 60,
        paddingBottom: 50,
        backgroundColor: Colors.pageBackground,
    },
    contentIcon: {
        width: 40,
        height: 'auto',
        marginRight: 15,
    },
    contentSection: {
        backgroundColor: Colors.white,
        borderRadius: 0,
        padding: '20px 30px',
        marginBottom: 20,
        [theme.breakpoints.up('sm')]: {
            borderRadius: 10,
            padding: '30px 30px',
        },
        '& a': {
            color: Colors.blueDk,
        },
        '&:last-of-type': {
            marginBottom: 0,
        },
        [theme.breakpoints.down('sm')]: {
            '& p': {
                marginBottom: 5,
                marginTop: 5,
            },
        },
    },
    subtitle: {
        fontSize: 27,
        marginBottom: 15,
        [theme.breakpoints.down('sm')]: {
            fontSize: 18,
        },
    },
    electionBanner: {
        backgroundColor: Colors.yellow,
        color: Colors.black,
        fontWeight: 700,
        fontSize: 20,
        letterSpacing: 0.5,
        padding: '12px 20px',
        marginBottom: 24,
        display: 'block',
        maxWidth: 'fit-content',
        [theme.breakpoints.down('sm')]: {
            fontSize: 16,
            padding: '10px 16px',
        },
    },
    socialBlock: {
        width: 60,
        height: 60,
        backgroundColor: Colors.white,
        padding: 15,
        display: 'inline-flex',
        border: `3px solid ${Colors.red}`,
        borderRight: 0,
        '&:last-child': {
            borderRight: `3px solid ${Colors.red}`,
        },
        '& svg': {
            color: Colors.red,
        },
        '&:hover, &:focus': {
            outline: 0,
            backgroundColor: Colors.red,
            '& svg': {
                color: Colors.white,
            },
        },
        [theme.breakpoints.down('sm')]: {
            padding: 10,
        },
    },
    instaHint: {
        color: Colors.black,
        opacity: 0.6,
        paddingBottom: 24,
    },
});
export default styles;
